"use client";

import React, { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import { AbilityProvider as CaslAbilityProvider } from "@casl/react";
import { createEmptyAbility, defineAbilitiesFor, AppAbility } from "@/lib/auth/ability";

interface AbilityProviderProps {
  children: React.ReactNode;
}

export function AbilityProvider({ children }: AbilityProviderProps) {
  const { data: session, status } = useSession();
  
  // Initialize with public/guest abilities
  const [ability] = useState<AppAbility>(() => createEmptyAbility());

  useEffect(() => {
    if (status !== "loading") {
      const newAbility = defineAbilitiesFor(session);
      ability.update(newAbility.rules);
    }
  }, [session, status, ability]);

  return (
    <CaslAbilityProvider value={ability}>
      {children}
    </CaslAbilityProvider>
  );
}
